import { render } from "./GroupListComponent.vue?vue&type=template&id=6b9b1663"
import script from "./GroupListComponent.vue?vue&type=script&lang=js"
export * from "./GroupListComponent.vue?vue&type=script&lang=js"

import "./GroupListComponent.vue?vue&type=style&index=0&id=6b9b1663&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__